import { HttpClient } from "@angular/common/http";
import { effect, inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ScreenStore, UserStore } from "../stores";
import { ColDef } from "ag-grid-community";

export class SecureDocumentUser
{
	public constructor(public inmateJurisdiction: string, public inmateFirstName: string, public inmateLastName: string,
		public inmateBookingNumber: string, public inmateBirthDate: Date, public inmateBookedDate: Date, public docBytes: any[])
	{
	}
}

export class InmateSecureDocumentCount
{
	public constructor(public inmateUserGlobalId: string, public inmateFirstName: string, public inmateLastName: string,
		public docCount: number, public inmateBookingNumber: String)
	{
	}
}

@Injectable()
export class InmateSecureDocumentCountRepository
{
	private requestMapping: string = "documents";
	private http: HttpClient;
	public ready: BehaviorSubject<boolean>;
	public userId: string | undefined | null;
	public screenSize: string;
	public isMobile: boolean = false;
	readonly userStore = inject(UserStore);
	readonly screenStore = inject(ScreenStore);

	public colDefs: ColDef[] = [
		{headerName: "Inmate", field: "inmateFirstName", filter: true},
		{headerName: "Uploads", field: "docCount"}
	];

	public constructor(http: HttpClient)
	{
		this.http = http;
		this.ready = new BehaviorSubject<boolean>(false);

		effect(() => {
			this.screenSize = this.screenStore.screenSize();
		})
		effect(() => {
			this.userId = this.userStore.userId();
			if (this.userId)
			{
				this.tableReady();
			}
		})
	}

	tableReady(): void {
		if (this.userId) {
			this.ready.next(true);
		}
	}

	public fetchAll(): Observable<InmateSecureDocumentCount[]>
	{
		return this.http.get<InmateSecureDocumentCount[]>(`${this.requestMapping}`);
	}
}
